import { render, staticRenderFns } from "./InputPrCost.vue?vue&type=template&id=6a60984c&scoped=true&"
import script from "./InputPrCost.vue?vue&type=script&lang=js&"
export * from "./InputPrCost.vue?vue&type=script&lang=js&"
import style0 from "./InputPrCost.vue?vue&type=style&index=0&id=6a60984c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60984c",
  null
  
)

export default component.exports